export default "__VITE_ASSET__CgoqNhdZ__"